import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
//import { toast } from 'react-toastify';
import { useAppSelector, useAppDispatch } from '../../Core/hooks';
import { getUser, login, setLoggingIn } from '../../Store/Auth';
import Footer from '../../Components/Footer';
import Navigation from '../../Components/Navigation';
//import Registration from '../../Modals/Registration';
//import Login from '../../Modals/Login';
import PricingTiers from '../../Components/PricingTiers';
import { isValidEmail } from '../../Helpers/isValidEmail';
import { joinWaitlist } from '../../Store/Utility';
import { HiArrowLongRight } from "react-icons/hi2";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

function RemoteTeams() {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const user = useAppSelector(getUser);
    const [email, setEmail] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const trackRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
        window.scrollTo(0, 0);
        //setActivationCode(queryParams.get('ac'));
        //setRecoveryCode(queryParams.get('ar'));
    }, []);

    useEffect(() => {
        const track = trackRef.current;
        const logos = track?.children;
        const visibleItems = 5;
        const totalItems = logos?.length || 0;
      
        if (!track || totalItems === 0) return;
      
        // Clone first 5 logos and append for infinite scroll illusion
        for (let i = 0; i < visibleItems; i++) {
            if (logos) {
                const clone = logos[i].cloneNode(true);
                track.appendChild(clone);
            }
        }
      
        let index = 0;
      
        const slide = () => {
          index++;
          track.style.transition = 'transform 0.6s ease-in-out';
          track.style.transform = `translateX(-${(100 / visibleItems) * index}%)`;
      
          // Reset instantly when we reach the clones
          if (index === totalItems) {
            setTimeout(() => {
              track.style.transition = 'none';
              track.style.transform = 'translateX(0%)';
              index = 0;
            }, 600); // match transition duration
          }
        };
      
        const interval = setInterval(slide, 3000);
      
        return () => clearInterval(interval);
      }, []);
      

/*
    useEffect(()=>{
        if (activationCode) {
            setShowLogin(true);
        }
    },[activationCode]);
*/
    useEffect(() => {
        if (user.accessToken !== "" && user.status !== "loading"){
            //dispatch(setLoggingIn(false));
            //navigate('/members/login');
            navigate('/dash');
        }
    }, [user]);

    return (
    <>
        <Navigation />
        <div style={{ backgroundColor: "#02152a", paddingBottom: "50px" }}>
            <div className="homeSplashContainer">
                <div className="desktop" style={{ alignItems: "start", justifyContent: "space-between", gap: "70px" }}>
                    <div style={{ flex: 1, textAlign: "left" }}>
                        <div style={{ fontSize: "16pt", color: "#fff", fontWeight: 450 }}>
                            chat, roadmaps, boards, and dashes
                        </div>
                        <h1 style={{ color: "#fff", fontSize: "30pt", fontWeight: 700 }}>
                            Work in Sync, From Anywhere
                        </h1>
                        <p style={{
                            margin: "30px auto 0px auto",
                            color: "#fff",
                            fontSize: "16pt",
                            fontWeight: 550
                        }}>
                            Herdr gives remote teams a shared workspace to plan, track, and deliver projects 
                            with clarity. Visual boards, smart task management, and built-in chat keep everyone 
                            aligned - no matter where they are.
                        </p>
                        <div style={{ marginTop: "45px" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-top");}}
                                className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Join Free <HiArrowLongRight size={30} color="#fff" />
                            </Link>
                        </div> 
                    </div>

                    <div style={{ flex: 1 }}>
                        <a href="#splash-section"><img src="images/herdr-home-collage-master.png" style={{ width: "100%" }} /></a>
                    </div>
                </div>
                <div className="mobile" style={{ width: "90%", margin: "0px auto" }}>
                    <div style={{ textAlign: "left" }}>
                        <div style={{ fontSize: "16pt", color: "#fff", fontWeight: 450 }}>
                            <img src="images/herdr-logo-cat-only.png" width="36px" 
                                style={{ paddingRight: "5px", position: "relative", top: "-6px" }}
                            />
                            <span style={{ fontWeight: "bold"}}>herdr</span> chat, roadmaps, boards, and dashes
                        </div>
                        <h1 style={{ marginTop: "20px", color: "#fff", fontSize: "30pt", fontWeight: 700 }}>
                            Work in Sync, From Anywhere
                        </h1>
                        <p style={{
                            margin: "30px auto 0px auto",
                            color: "#fff",
                            fontSize: "16pt",
                            fontWeight: 550
                        }}>
                            Herdr gives remote teams a shared workspace to plan, track, and deliver projects 
                            with clarity. Visual boards, smart task management, and built-in chat keep everyone 
                            aligned - no matter where they are.
                        </p>
                        <div style={{ marginTop: "45px" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-top");}}
                                className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Join Free <HiArrowLongRight size={30} color="#fff" />
                            </Link>
                        </div> 
                    </div>

                    <div style={{ marginTop: "40px" }}>
                        <a href="#splash-section"><img src="images/herdr-home-collage-master.png" style={{ width: "100%" }} /></a>
                    </div>
                </div>
            </div>

        </div>  

        <section className="logo-section">
            <div className="logo-header">
                <h2>To us who work late, think big, and ship fast</h2>
                <p style={{ marginTop: "20px" }}>
                    We turn bold ideas into shipped products. Sprinting through late nights & 
                    multiple time zones. <b>LET'S GO!!</b>
                </p>
            </div>
            <div className="carousel-wrapper">
                <div className="carousel-track" ref={trackRef}>
                    <img src="/images/clientLogo1.png" />
                    <img src="/images/clientLogo2.png" />
                    <img src="/images/clientLogo3.png" />
                    <img src="/images/clientLogo4.png" />
                    <img src="/images/clientLogo5.png" />
                    <img src="/images/clientLogo6.png" />
                    <img src="/images/clientLogo7.png" />
                    <img src="/images/clientLogo8.png" />
                    <img src="/images/clientLogo9.png" />
                    <img src="/images/clientLogo10.png" />
                </div>
            </div>
        </section>

        <div className="remoteTeamStatContainer">
            <hr style={{ margin: "0px auto 40px auto", color: "#F8F9FA", borderWidth: "1.5", width: "80%" }} />
            <div className="remoteTeamStats">
                <div className="remoteTeamStat">
                    <div style={{ padding: "0px 50px" }}>
                        <div style={{ textAlign: "center", marginBottom: "40px" }}>
                            <img src='/images/up-arrow-blue.png' style={{ width: "200px" }} />
                        </div>
                        <div style={{ color: "#fff" }}>
                            <h2 style={{ fontSize: "1.8rem", fontWeight: 600, marginBottom: "20px" }}>
                                2x Your Project Delivery
                            </h2>
                            <div style={{ fontSize: "1.4rem", color: "#efefef" }}>
                                Teams using Herdr report delivering projects nearly twice as fast
                                by eliminating tool sprawl and syncing everyone in one place.
                            </div>
                        </div>
                    </div>
                </div>
                <div className="remoteTeamStat">
                    <div style={{ padding: "0px 50px" }}>
                        <div style={{ textAlign: "center", marginBottom: "40px" }}>
                            <img src='/images/checkmark-blue.png' style={{ width: "200px" }} />
                        </div>
                        <div style={{ color: "#fff" }}>
                            <h2 style={{ fontSize: "1.8rem", fontWeight: 600, marginBottom: "20px" }}>
                                Trusted By Remote Teams in 20+ Countries
                            </h2>
                            <div style={{ fontSize: "1.4rem", color: "#efefef" }}>
                                From roadmaps to chat, Herdr powers seemless team-work for 
                                early-stage builders and small, remote teams
                            </div>
                        </div>
                    </div>
                </div>
                <div className="remoteTeamStat">
                    <div style={{ padding: "0px 50px" }}>
                        <div style={{ textAlign: "center", marginBottom: "40px" }}>
                            <img src='/images/collaboration-blue.png' style={{ width: "200px" }} />
                        </div>
                        <div style={{ color: "#fff" }}>
                            <h2 style={{ fontSize: "1.8rem", fontWeight: 600, marginBottom: "20px" }}>
                                72% of Users Say They Feel More Organized
                            </h2>
                            <div style={{ fontSize: "1.4rem", color: "#efefef" }}>
                                Herdr's simple, visual workspaces help remote teams
                                stay on top of tasks without the overhead of traditional tools.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 


        <div className="mobile80width" style={{ textAlign: "center", padding: "40px 20px 20px 20px", maxWidth: "1000px", margin: "0 auto" }}>
            <h1 style={{ fontSize: "3rem", fontWeight: "700", marginBottom: "10px" }}>
                Move Faster Together with Herdr
            </h1>
            <p style={{ lineHeight: "1.2", fontSize: "2rem", marginBottom: "40px", fontWeight: "500" }}>
                Your all-in-one workspace to plan, track, and collaborate - wherever your team is.
            </p>
            <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "30px" }}>
                <ul style={{ listStyle: "none", padding: 0, textAlign: "left", fontSize: "1.5rem" }}>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Brainstorm, prioritize, and organize work in one place
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Share visual roadmaps to align teammates and stakeholders
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Track progress with simple, intuitive Kanban boards
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Collaborate instantly with built-in real-time chat
                    </li>
                    <li style={{ marginBottom: "20px" }}>
                        <IoCheckmarkCircleOutline color="#e55c02" size={40} /> Stay focused with a clean, clutter-free interface
                    </li>
                </ul>
            </div>
        </div>

        <div className="homeOrangeWave">           
            <div className="wave">
                <svg name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
                </svg>
            </div>
            <div className="homePagePricingTiersContainer">
                <PricingTiers 
                    mostPopularButtonBackgroundColor='#000' 
                    mostPopularButtonColor='#fff'
                    mostPopularButtonBorder='3px solid #e55c02' 
                    page="home"
                />
            </div>
        </div>

        <div>
            <h2 style={{ width: "80%", fontSize: "2.8rem", fontWeight: 600, margin: "60px auto 60px auto", textAlign: "center" }}>
                Why Teams Are Switching to Herdr
            </h2>
            <div className="remoteTeamPeople">
                <div className="remoteTeamPeopleBucket">
                    <div style={{ padding: "0px 50px" }}>
                        <div style={{ marginBottom: "20px" }}>
                            <img src='/images/testimonial1.png' style={{ width: "225px", borderRadius: "50%" }} />
                        </div>                  
                        <h2 style={{ fontStyle: "italic", fontSize: "1.4rem", fontWeight: 600, marginBottom: "10px" }}>
                            Herdr replaced three tools for us overnight
                        </h2>
                        <div style={{ fontStyle: "italic", fontSize: "1.2rem", color: "#535353" }}>
                            As a fully remote dev team, we were bouncing between docs, boards, and chat apps. 
                            Herdr brought it all into one clean, easy-to-use workspace.
                        </div>
                        <div style={{ fontSize: "1rem", fontWeight: 400, marginTop: "10px" }}>
                            - Jamie L., CTO at Prex
                        </div>
                    </div>
                </div>  
                <div className="remoteTeamPeopleBucket">   
                    <div style={{ padding: "0px 50px" }}>   
                        <div style={{ marginBottom: "20px" }}>
                            <img src='/images/testimonial3.png' style={{ width: "225px", borderRadius: "50%" }} />
                        </div>                
                        <h2 style={{ fontStyle: "italic", fontSize: "1.4rem", fontWeight: 600, marginBottom: "10px" }}>
                            We've never felt more aligned as a team
                        </h2>
                        <div style={{ fontStyle: "italic", fontSize: "1.2rem", color: "#535353" }}>
                            Between the roadmap, Kanban, and chat, Herdr keeps everyone on the 
                            same page-especially across time zones.
                        </div>
                        <div style={{ fontSize: "1rem", fontWeight: 400, marginTop: "10px" }}>
                            - Nina A., Product Manager at Looperwillo Works
                        </div>
                    </div>
                </div>  
                <div className="remoteTeamPeopleBucket"> 
                    <div style={{ padding: "0px 50px" }}> 
                        <div style={{ marginBottom: "20px" }}>
                            <img src='/images/testimonial2.png' style={{ width: "225px", borderRadius: "50%" }} />
                        </div>                     
                        <h2 style={{ fontStyle: "italic", fontSize: "1.4rem", fontWeight: 600, marginBottom: "10px" }}>
                            It's just the right amount of everything
                        </h2>
                        <div style={{ fontStyle: "italic", fontSize: "1.2rem", color: "#535353" }}>
                            Most tools feel bloated. Herdr is fast, focused, and simple to onboard. 
                            Our whole team adopted it within a day.
                        </div>
                        <div style={{ fontSize: "1rem", fontWeight: 400, marginTop: "10px" }}>
                            - Ravi S., Co-founder of TenBy10 Labs
                        </div>
                    </div>
                </div> 
            </div>
            <hr style={{ margin: "60px auto 0px auto", color: "gray", borderWidth: "1", width: "60%" }} />
        </div>

        <div id="splash-section" >
            <div className="mobile80width homeSplashContainer" style={{ position: "relative" }}>
                <div style={{ margin: "20px 0px 60px 0px" }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Plan Like a Boss. Execute Without the Chaos.
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Strategic roadmaps meet real execution. Connect your big-picture plans to 
                            actionable Kanban boards, track progress intuitively, and keep your team 
                            aligned with live dashboards and smart workflows.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/roadmap-01.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-roadmap-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Build Your Roadmap <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Focus More. Click Less. Kanban Reinvented.
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            No due dates. Forget setting deadlines for every task. Our intuitive 
                            board statuses, automatic completion tracking, and built-in stopwatch let your 
                            team stay focused and flexible. This is Kanban reimagined for Web 3.0 - fewer clicks, 
                            smarter flow, and built for real agile work.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/kanban-02.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-kanban-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Try Smarter Kanban <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Simple Reports & Dashboards That Keep You Focused
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Stay on top of what matters with intuitive dashboards that give you visibility 
                            across every project, task, and roadmap - all in one place. Track progress, 
                            spot blockers, and keep your team aligned.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/dashboard-01.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-dash-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                See Your Work Clearly <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Integrated Team Chat for Seamless, Connected Collaboration
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Stay aligned without switching tools. Slack-style channels and direct messages 
                            are fully integrated with your Kanban boards and roadmaps - so you can comment on 
                            a card, start a conversation, or jump into a project thread without missing a beat.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/chat-01.jpg" style={{ width: "100%" }} />
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", margin: "0px auto 60px auto"  }}>
                    <div className="feature-blurb" style={{ margin: "0px auto 60px auto" }}>
                        <div style={{ marginTop: "10px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-chat-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Chat Where Work Happens <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                        <h2 style={{ textAlign: "center", fontWeight: "600", fontSize: "2rem", marginBottom: "20px" }}>
                            Share Roadmaps and Projects - No Paywall, No Friction
                        </h2>
                        <div style={{ fontSize: "1.4rem", textAlign: "justify", color: "#555" }}>
                            Invite collaborators without worrying about cost. Share your roadmaps and projects 
                            freely - no paid seats, no upgrades required. Built to empower lean teams to build 
                            great things together.
                        </div>
                    </div>
                    <div style={{ width: "100%" }}>
                        <div>
                            <img src="/images/collaboration-01.jpg" style={{ width: "100%" }} />
                        </div>
                        <div style={{ marginTop: "60px", marginBottom: "60px", textAlign: "center" }}>
                            <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-collaborate-button");}}
                                className="orangeButton" style={{ padding: "12px 36px", fontWeight: 500,
                                    fontSize: "16pt", textDecoration: "none", color: "#fff"
                            }}>
                                Share Without Limits <span className="hideForMobile"><HiArrowLongRight size={30} color="#fff" /></span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style={{ backgroundColor: "#02152a" }}>
            <div className="mobile80width homeSplashContainer" style={{ position: "relative" }}>
                <h2 style={{ margin: "40px 0px", color: "#fff", fontWeight: "600", fontSize: "2.6rem"}}>
                    Why startups love Herdr.io
                </h2>
                <div className="desktopFlex">
                    <div className="desktopInlineBlock" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px" }}>
                            From Idea to Launch, Fast
                        </div>
                        <div>
                            Herdr helps founders move quickly from brainstorming to execution with roadmaps, boards, 
                            and real-time chat - no bloated features, just what startups need.
                        </div>
                    </div>
                    <div className="mobileMarginTop20 desktopInlineBlock desktopLeftMargin20" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px"}}>
                            Built for Lean, Scrappy Teams
                        </div>
                        <div>
                            Track what's happening, what's blocked, and what's next - all in one place. 
                            Herdr brings visibility to fast-moving teams without slowing them down.
                        </div>
                    </div>
                </div>
                <div className="desktopFlex" style={{ marginTop: "20px"}}>
                    <div  className="desktopInlineBlock" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px"}}>
                            Impress Investors & Teammates
                        </div>
                        <div>
                            Share beautiful, interactive roadmaps to keep stakeholders aligned. 
                            Whether you're pitching or onboarding, Herdr makes your vision clear.
                        </div>
                    </div>
                    <div className="mobileMarginTop20 desktopInlineBlock desktopLeftMargin20" style={{
                        boxShadow: "4px 4px 14px 0px rgba(0, 0, 0, 0.1)",
                        backgroundColor: "#fff",
                        borderRadius: "20px",
                        borderColor: "#fff",
                        textAlign: "left",
                        padding: "20px",
                        height: "250px",
                    }}>
                        <div style={{ fontSize: "14pt", fontWeight: "bold", marginBottom: "20px"}}>
                            Collaborate Without the Noise
                        </div>
                        <div>
                            Integrated chat keeps conversations tied to tasks and 
                            roadmaps, so you never lose context or momentum.
                        </div>
                    </div>
                </div>
                <div style={{ paddingBottom: "75px" }}></div>
                <img src="images/man-woman.png"  style={{ width: "53%", height: "auto", position: "absolute", bottom: "0", right: "-12%" }} />
            </div>
        </div>

        <div className="hideForMobile">
            <div style={{ display: "flex", position: "relative", backgroundColor: "#F8F9FA", padding: "60px 0px" }}>
                <div style={{ display: "inline-block", textAlign: "right", width: "50%", 
                    margin: "0px auto", paddingRight: "80px"
                }}>
                    <img src="images/herdr-orange-logo-cat-v1.png" style={{ width: "200px" }} />
                </div>
                <div style={{ display: "inline-block", textAlign: "left", width: "50%", margin: "0px auto" }}>
                    <h2>Ideas Into Impact, Remotely</h2>
                    <div style={{ fontSize: "1.5rem" }}>Use Herdr today</div>
                    <div style={{ marginTop: "45px" }}>
                        <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-bottom");}}
                            className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                fontSize: "16pt", textDecoration: "none", color: "#fff"
                        }}>
                            Start For Free <HiArrowLongRight size={30} color="#fff" />
                        </Link>
                    </div> 
                </div>
            </div>
        </div>

        <div className="hideForDesktop" style={{ width: "80%", margin: "0px auto", textAlign: "center" }}>
            <div style={{ position: "relative", padding: "60px 0px" }}>
                <div style={{ display: "inline-block", textAlign: "center", margin: "0px auto" }}>
                    <h2>Turn Ideas Into Impact, Remotely</h2>
                    <div style={{ fontSize: "1.5rem" }}>Use Herdr today</div>
                    <div style={{ marginTop: "45px" }}>
                        <Link to="" onClick={(e) => { e.preventDefault(); navigate("/register/starter/home-bottom");}}
                            className="greenButton" style={{ padding: "12px 36px", fontWeight: 500,
                                fontSize: "16pt", textDecoration: "none", color: "#fff"
                        }}>
                            Start For Free <HiArrowLongRight size={30} color="#fff" />
                        </Link>
                    </div> 
                </div>
            </div>
        </div>

        {/*<Login visible={showLogin} visibleHandler={toggleLogin} activationCode={activationCode} recoveryCode={recoveryCode} />
        <Registration visible={showRegistration} visibleHandler={toggleRegistration} />*/}
        <Footer style={{ backgroundColor: "#02152a", position: "relative" }} />
    </>
    );
}

export default RemoteTeams;